export const HomeMessages = {
  pageTitle: 'Home',
  welcome: 'Welkom op het ordersysteem van Fore Fiber!',
  about: {
    title: 'Over dit portal',
    description:
      'Dit orderportaal stelt u in staat om eenvoudig en efficiënt bestellingen te plaatsen voor Fore Fiber diensten. Via dit systeem kunt u:',
    features: {
      quote: 'Offertes accepteren',
      device: 'Bestellingen plaatsen via de QR code op uw apparaat',
    },
  },
  getStarted: {
    title: 'Aan de slag',
    description:
      'U kunt een bestelling starten door op de link in uw offerte mail te klikken of door een apparaat te scannen met de QR-code.',
  },
  support: {
    title: 'Hulp nodig?',
    description: 'Neem contact met ons op via de contactgegevens in uw offerte of bestelling.',
  },
};
